import VerticalTabs from './VerticalTabs/VerticalTabs';

function App() {
  return <div>
    <VerticalTabs />
  </div>
}

export default App;
